import { PlantLayoutAreaDrawingsThemeSizeConfig } from './types';

const medium: PlantLayoutAreaDrawingsThemeSizeConfig = {
  plantLayoutAreaDrawings: {},
};

export default medium;
